import {
  type U3140PdfAnnotationToolbarPreset,
  u3140ToolbarPresetSidebarHoverTitle,
  u3140ToolbarPresetSidebarRowAppearance,
} from "../../U3140PdfAnnotationsService";

export interface U3140PdfAnnotationToolbarPresetSidebarProps {
  presets: U3140PdfAnnotationToolbarPreset[];
  disabled: boolean;
  onApply: (preset: U3140PdfAnnotationToolbarPreset) => void;
  getApplyTitle: (preset: U3140PdfAnnotationToolbarPreset) => string;
  listAriaLabel: string;
  /** Id du dernier préréglage appliqué (affichage d’une bordure en pointillés). */
  selectedPresetId?: string | null;
}

/**
 * Liste verticale de préréglages à gauche du PDF (pleine largeur de colonne, fond dérivé des styles).
 */
export function U3140PdfAnnotationToolbarPresetSidebar({
  presets,
  disabled,
  onApply,
  getApplyTitle,
  listAriaLabel,
  selectedPresetId = null,
}: U3140PdfAnnotationToolbarPresetSidebarProps) {
  if (presets.length === 0) {
    return null;
  }

  return (
    <nav
      className="flex max-h-full min-h-0 w-56 min-w-52 max-w-[18rem] shrink-0 flex-col self-stretch overflow-y-auto border-r border-gray-200 bg-gray-50"
      aria-label={listAriaLabel}
    >
      <ul className="m-0 flex list-none flex-col gap-y-1.5 px-2 py-2">
        {presets.map((preset) => {
          const row = u3140ToolbarPresetSidebarRowAppearance(preset.styles, String(preset.id));
          const isSelected =
            selectedPresetId != null && selectedPresetId !== "" && String(preset.id) === selectedPresetId;
          return (
            <li key={preset.id} className="w-full shrink-0">
              <div
                className={
                  isSelected
                    ? "rounded-md border border-dashed border-gray-800 bg-gray-50 p-[3px]"
                    : "rounded-md"
                }
              >
                <button
                  type="button"
                  className="w-full rounded-md px-3 py-2.5 text-left text-sm font-medium leading-snug transition-[filter] hover:brightness-[0.97] disabled:cursor-not-allowed disabled:opacity-60"
                  style={{ backgroundColor: row.backgroundColor, color: row.color }}
                  disabled={disabled}
                  title={u3140ToolbarPresetSidebarHoverTitle(preset, getApplyTitle(preset))}
                  aria-current={isSelected ? "true" : undefined}
                  onClick={() => onApply(preset)}
                >
                  {preset.label}
                </button>
              </div>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
